import { useCallback, useState } from "react";
import { APP_CONFIG } from "../constants/app";
import { Turno } from "../interfaces";

export const useTurnosCancelacion = () => {
  const [cancelandoTurno, setCancelandoTurno] = useState(false);
  const [progresoCancelacion, setProgresoCancelacion] = useState({ actual: 0, total: 0 });

  const cancelarTurnos = useCallback(async (turnos: Turno[], cancelarFn: (codigo: number) => Promise<void>) => {
    setCancelandoTurno(true);
    setProgresoCancelacion({ actual: 0, total: turnos.length });

    let exitosos = 0;
    let errores = 0;

    for (let i = 0; i < turnos.length; i++) {
      setProgresoCancelacion({ actual: i + 1, total: turnos.length });

      try {
        await cancelarFn(turnos[i].codigo);
        exitosos++;
      } catch (e) {
        errores++;
        console.error(`Error cancelando turno ${turnos[i].codigo}:`, e);
      }

      await new Promise((resolve) => setTimeout(resolve, APP_CONFIG.DELAY_BETWEEN_REQUESTS));
    }

    setCancelandoTurno(false);
    setProgresoCancelacion({ actual: 0, total: 0 });
    return { exitosos, errores };
  }, []);

  return { cancelandoTurno, progresoCancelacion, cancelarTurnos };
};
